// "use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _attachThemeAttrs = _interopRequireDefault(require("../../../styles/helpers/attachThemeAttrs"));
function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    top: 50%;\n    margin-top: -0.0625rem;\n    display: block;\n    width: 0%;\n    height: 1px;\n    border: solid 0.5px var(--stepButtonColor)", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIndicatorBar = (0, _attachThemeAttrs["default"])(_styledComponents["default"].div)(_templateObject(), function (props) {
  return null;
});
var _default = StyledIndicatorBar;
exports["default"] = _default;